var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClasses,attrs:{"disabled":_vm.state.loading},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.buttonLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }